// Source for public lands colors: https://www.figma.com/design/B7oyzdXDXbRUGayrIwJnRp/Adv-Planning-2026--Handoff-?node-id=513-35366&m=dev
export const activeColor = '#FF00FF';
export const USFSColor = '#65AD5F';
export const NPSColor = '#75564B';
export const BLMColor = '#F59C37';
export const SPRColor = '#CDDB49';
export const FWSColor = '#4393EC';
export const CITYColor = '#FEC12F';
export const CNTYColor = '#FD5830';
export const TRIBColor = '#E72566';
export const USACEColor = '#21BCD3';
export const USBRColor = '#9B2FAE';
export const NGOColor = '#617D8B';
export const REGColor = '#10796B';
export const SDNRColor = '#10796B';
export const DODColor = '#585858';
export const defaultColor = '#66BB6A';
